import script from "./ReactionList.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReactionList.vue?vue&type=script&lang=ts&setup=true"

import "./ReactionList.vue?vue&type=style&index=0&id=7dcfb3c3&lang=scss"
import "./ReactionList.vue?vue&type=style&index=1&id=7dcfb3c3&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dcfb3c3"]])

export default __exports__